module.exports = __webpack_public_path__ + "img/placeList5.85b40950.png";